import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from "./context/AuthContext";
import { VehicleProvider } from "./context/VehicleContext";

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <AuthProvider>

    <VehicleProvider>

      <App />

    </VehicleProvider>

  </AuthProvider>
);
reportWebVitals();